import type { TLoginHintBadge } from "./types";
import { getAllPathParam } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "user/login-hint-badges";

export default createService(SLUG, {
  getAll: getAllPathParam<TLoginHintBadge>(SLUG),
  getInside: getAllPathParam<TLoginHintBadge>(`${SLUG}/inside`),
});
